import { CreatedByType } from 'types/common';

// export const createdByOptions: CreatedByType[] = ['all', 'admin', 'parser', 'user'];
export const createdByOptions: CreatedByType[] = ['all', 'withOwner', 'withoutOwner', 'isFromNewspaper'];

export const NAME = 'createdByData';

export const DEFAULT_CREATED_BY: CreatedByType = 'all';
